import styled from 'styled-components'

type FrameVariant = 'alpha'

type FrameProps = {
  variant?: FrameVariant
} & React.HTMLAttributes<HTMLDivElement>

export const Frame: React.FC<FrameProps> = ({
  variant = 'alpha',
  ...props
}) => {
  return <Root $variant={variant} {...props}></Root>
}

const Root = styled.div<{ $variant: FrameVariant }>`
  background: #1b1b1b;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
`
